import React from "react";
import Swal from "sweetalert2";

const CallToAction = ({ data }) => {
  // 🔹 Function to handle redirect with dynamic ID
  const handleRedirect = (id) => {
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        title: "⚠️ Login Required",
        text: "Please login first to access your dashboard.",
        icon: "warning",
        confirmButtonText: "Go to Login",
        confirmButtonColor: "rgb(204, 102, 0)",
      }).then((result) => {
        if (result.isConfirmed) window.location.href = "/login";
      });
      return;
    }

    // ✅ Redirect with ID and token
    const url = `https://admin.businessunbuzzed.com/plans/checkout/${id}?token=${token}`;
    window.location.href = url;
  };

  return (
    <section id="call-to-action" className="cta-section">
      <div className="container text-center">
        <h2>{data?.title}</h2>
        <p className="subtitle">{data?.subtitle}</p>

        <div className="cta-buttons">
          {data?.mainActions?.map((btn, i) => (
            <button
              key={i}
              onClick={() => handleRedirect(btn.id)} // optional ID if added later
              className="btn-main"
            >
              {btn.label}
            </button>
          ))}
        </div>

        <p className="guarantee">{data?.guarantee}</p>

        <div className="quick-options row">
          {data?.quickOptions?.map((opt, i) => (
            <div key={i} className="col-md-4">
              <div className="quick-card">
                <h4>{opt.name}</h4>
                <p className="price">{opt.price}</p>
                <p className="desc">{opt.desc}</p>
                <button
                  onClick={() => handleRedirect(opt.id)} // 👈 dynamic ID from JSON
                  className="btn-small"
                >
                  {opt.cta}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
